__turbopack_context__.v({
  "divider": "sBKPIq_divider",
});
